/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopReport', 'model/Workshop', 'model/WorkshopCloneSettings', 'model/FileTransferHelperEntity'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkshopReport'), require('../model/Workshop'), require('../model/WorkshopCloneSettings'), require('../model/FileTransferHelperEntity'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopReport, root.ForStractionServiceApi.Workshop, root.ForStractionServiceApi.WorkshopCloneSettings, root.ForStractionServiceApi.FileTransferHelperEntity);
  }
}(this, function(ApiClient, WorkshopReport, Workshop, WorkshopCloneSettings, FileTransferHelperEntity) {
  'use strict';

  /**
   * Workshop service.
   * @module api/WorkshopApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkshopApi. 
   * @alias module:api/WorkshopApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workshopAddAllReportsPut operation.
     * @callback module:api/WorkshopApi~workshopAddAllReportsPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAllReports
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/WorkshopReport>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.templateID 
     * @param {Boolean} opts.useTemplateCompany  (default to false)
     * @param {module:api/WorkshopApi~workshopAddAllReportsPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.workshopAddAllReportsPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopAddAllReportsPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopAddAllReportsPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'templateID': opts['templateID'],
        'useTemplateCompany': opts['useTemplateCompany']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/Workshop/addAllReports', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopAddPut operation.
     * @callback module:api/WorkshopApi~workshopAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopReport} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.templateID 
     * @param {Boolean} opts.useTemplateCompany  (default to false)
     * @param {module:api/WorkshopApi~workshopAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.workshopAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'templateID': opts['templateID'],
        'useTemplateCompany': opts['useTemplateCompany']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/Workshop/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopAddTemplatePut operation.
     * @callback module:api/WorkshopApi~workshopAddTemplatePutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addTemplate
     * @param {String} _4SAPIAppID 
     * @param {module:model/Workshop} body 
     * @param {module:api/WorkshopApi~workshopAddTemplatePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.workshopAddTemplatePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopAddTemplatePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopAddTemplatePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/Workshop/addTemplate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopClearWorkshopDataGet operation.
     * @callback module:api/WorkshopApi~workshopClearWorkshopDataGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clearWorkshopData
     * @param {String} _4SAPIAppID 
     * @param {Integer} workshopID 
     * @param {module:api/WorkshopApi~workshopClearWorkshopDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopReport}
     */
    this.workshopClearWorkshopDataGet = function(_4SAPIAppID, workshopID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopClearWorkshopDataGet";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling workshopClearWorkshopDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopReport;

      return this.apiClient.callApi(
        '/Workshop/clearWorkshopData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopClonePut operation.
     * @callback module:api/WorkshopApi~workshopClonePutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clone
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopCloneSettings} body 
     * @param {module:api/WorkshopApi~workshopClonePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopReport>}
     */
    this.workshopClonePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopClonePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopClonePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopReport];

      return this.apiClient.callApi(
        '/Workshop/clone', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopConvertToTemplateGet operation.
     * @callback module:api/WorkshopApi~workshopConvertToTemplateGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * convertToTemplate
     * @param {String} _4SAPIAppID 
     * @param {Integer} workshopID 
     * @param {Boolean} createNew 
     * @param {module:api/WorkshopApi~workshopConvertToTemplateGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopReport}
     */
    this.workshopConvertToTemplateGet = function(_4SAPIAppID, workshopID, createNew, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopConvertToTemplateGet";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling workshopConvertToTemplateGet";
      }

      // verify the required parameter 'createNew' is set
      if (createNew == undefined || createNew == null) {
        throw "Missing the required parameter 'createNew' when calling workshopConvertToTemplateGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID,
        'createNew': createNew
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopReport;

      return this.apiClient.callApi(
        '/Workshop/convertToTemplate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopCreateWorkshopDataZipGet operation.
     * @callback module:api/WorkshopApi~workshopCreateWorkshopDataZipGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createWorkshopDataZip
     * @param {String} _4SAPIAppID 
     * @param {Integer} workshopID 
     * @param {module:api/WorkshopApi~workshopCreateWorkshopDataZipGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.workshopCreateWorkshopDataZipGet = function(_4SAPIAppID, workshopID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopCreateWorkshopDataZipGet";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling workshopCreateWorkshopDataZipGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Workshop/createWorkshopDataZip', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopDeleteGet operation.
     * @callback module:api/WorkshopApi~workshopDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopApi~workshopDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Workshop/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopEditPut operation.
     * @callback module:api/WorkshopApi~workshopEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/Workshop} body 
     * @param {module:api/WorkshopApi~workshopEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Workshop/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopGenerateCustomBackgroundImageGet operation.
     * @callback module:api/WorkshopApi~workshopGenerateCustomBackgroundImageGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateCustomBackgroundImage
     * @param {String} _4SAPIAppID 
     * @param {String} prompt 
     * @param {module:api/WorkshopApi~workshopGenerateCustomBackgroundImageGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.workshopGenerateCustomBackgroundImageGet = function(_4SAPIAppID, prompt, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopGenerateCustomBackgroundImageGet";
      }

      // verify the required parameter 'prompt' is set
      if (prompt == undefined || prompt == null) {
        throw "Missing the required parameter 'prompt' when calling workshopGenerateCustomBackgroundImageGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'prompt': prompt
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Workshop/generateCustomBackgroundImage', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopLoadAllGet operation.
     * @callback module:api/WorkshopApi~workshopLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/WorkshopApi~workshopLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopReport>}
     */
    this.workshopLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopReport];

      return this.apiClient.callApi(
        '/Workshop/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopLoadAllSystemTemplatesGet operation.
     * @callback module:api/WorkshopApi~workshopLoadAllSystemTemplatesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAllSystemTemplates
     * @param {String} _4SAPIAppID 
     * @param {module:api/WorkshopApi~workshopLoadAllSystemTemplatesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopReport>}
     */
    this.workshopLoadAllSystemTemplatesGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopLoadAllSystemTemplatesGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopReport];

      return this.apiClient.callApi(
        '/Workshop/loadAllSystemTemplates', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopLoadGet operation.
     * @callback module:api/WorkshopApi~workshopLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.translate  (default to false)
     * @param {module:api/WorkshopApi~workshopLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopReport}
     */
    this.workshopLoadGet = function(_4SAPIAppID, entityID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'translate': opts['translate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopReport;

      return this.apiClient.callApi(
        '/Workshop/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopLoadManyPut operation.
     * @callback module:api/WorkshopApi~workshopLoadManyPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadMany
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/WorkshopApi~workshopLoadManyPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopReport>}
     */
    this.workshopLoadManyPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopLoadManyPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopLoadManyPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopReport];

      return this.apiClient.callApi(
        '/Workshop/loadMany', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopPreviewGet operation.
     * @callback module:api/WorkshopApi~workshopPreviewGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * preview
     * @param {String} _4SAPIAppID 
     * @param {Integer} workshopID 
     * @param {module:api/WorkshopApi~workshopPreviewGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopReport}
     */
    this.workshopPreviewGet = function(_4SAPIAppID, workshopID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopPreviewGet";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling workshopPreviewGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopReport;

      return this.apiClient.callApi(
        '/Workshop/preview', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopRecreateFromTemplateGet operation.
     * @callback module:api/WorkshopApi~workshopRecreateFromTemplateGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * recreateFromTemplate
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopApi~workshopRecreateFromTemplateGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopReport}
     */
    this.workshopRecreateFromTemplateGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopRecreateFromTemplateGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopRecreateFromTemplateGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopReport;

      return this.apiClient.callApi(
        '/Workshop/recreateFromTemplate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopSendInvitationsPut operation.
     * @callback module:api/WorkshopApi~workshopSendInvitationsPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendInvitations
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} workshopID 
     * @param {Object} opts Optional parameters
     * @param {String} opts.coverMessage  (default to )
     * @param {Boolean} opts.sendEmail  (default to false)
     * @param {module:api/WorkshopApi~workshopSendInvitationsPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopSendInvitationsPut = function(_4SAPIAppID, body, workshopID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopSendInvitationsPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopSendInvitationsPut";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling workshopSendInvitationsPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID,
        'coverMessage': opts['coverMessage'],
        'sendEmail': opts['sendEmail']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Workshop/sendInvitations', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopStoreCustomBackgroundImagePut operation.
     * @callback module:api/WorkshopApi~workshopStoreCustomBackgroundImagePutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * storeCustomBackgroundImage
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Integer} workshopID 
     * @param {module:api/WorkshopApi~workshopStoreCustomBackgroundImagePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.workshopStoreCustomBackgroundImagePut = function(_4SAPIAppID, body, workshopID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopStoreCustomBackgroundImagePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopStoreCustomBackgroundImagePut";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling workshopStoreCustomBackgroundImagePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Workshop/storeCustomBackgroundImage', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopStoreWorkshopScreenshotPut operation.
     * @callback module:api/WorkshopApi~workshopStoreWorkshopScreenshotPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * storeWorkshopScreenshot
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Integer} workshopID 
     * @param {module:api/WorkshopApi~workshopStoreWorkshopScreenshotPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.workshopStoreWorkshopScreenshotPut = function(_4SAPIAppID, body, workshopID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopStoreWorkshopScreenshotPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopStoreWorkshopScreenshotPut";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling workshopStoreWorkshopScreenshotPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Workshop/storeWorkshopScreenshot', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopToggleMultiUserStatusGet operation.
     * @callback module:api/WorkshopApi~workshopToggleMultiUserStatusGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * toggleMultiUserStatus
     * @param {String} _4SAPIAppID 
     * @param {Integer} workshopID 
     * @param {Boolean} isSingleUser 
     * @param {module:api/WorkshopApi~workshopToggleMultiUserStatusGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopReport}
     */
    this.workshopToggleMultiUserStatusGet = function(_4SAPIAppID, workshopID, isSingleUser, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopToggleMultiUserStatusGet";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling workshopToggleMultiUserStatusGet";
      }

      // verify the required parameter 'isSingleUser' is set
      if (isSingleUser == undefined || isSingleUser == null) {
        throw "Missing the required parameter 'isSingleUser' when calling workshopToggleMultiUserStatusGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID,
        'isSingleUser': isSingleUser
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopReport;

      return this.apiClient.callApi(
        '/Workshop/toggleMultiUserStatus', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
